import axios from "../../apis/Api";
import history, { logout } from "../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_MBL_DISTRIBUTOR_ONBOARDING_LIST } from "../../Types";

export const getMBLDistributorOnboardingList =
  (requestData) => async (dispatch) => {
    dispatch(showLoading());
    await axios
      .get(`api/DistributorOnboarding/GetDistributorOnbaordList`, requestData)
      .then(({ data }) => {
        if (data)
          // ;
          dispatch({
            type: GET_MBL_DISTRIBUTOR_ONBOARDING_LIST,
            payload: data.response,
          });
        dispatch(hideLoading());
      })
      .catch(function (error) {
        dispatch(hideLoading());
        if (error.response) {
          if (error.response.status === 401) {
            logout();
            history.push("/login");
            history.go("/login");
          } else if (error.response.data)
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message,
            );
          else {
            toast.error("Error while processing the request");
          }
        }
      });
  };
export const submitDistributorOnboarding =
  (requestData, onSuccess) => async (dispatch) => {
    dispatch(showLoading());

    await axios
      .post(`api/DistributorOnboarding/Create`, requestData)
      .then(({ data }) => {
        if (data?.isSuccess) {
          toast.success(
            data.message || "Distributor onboarding submitted successfully",
          );

          // Optional callback (close modal, refresh list, etc.)
          if (onSuccess) onSuccess();

          // Optional: refresh onboarding list after submit
          dispatch(getMBLDistributorOnboardingList({}));
        } else {
          toast.error(data?.message || "Failed to submit onboarding");
        }

        dispatch(hideLoading());
      })
      .catch((error) => {
        dispatch(hideLoading());

        if (error.response) {
          if (error.response.status === 401) {
            logout();
            history.push("/login");
            history.go("/login");
          } else if (error.response.data) {
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message,
            );
          } else {
            toast.error("Error while processing the request");
          }
        } else {
          toast.error("Network error");
        }
      });
  };
